<template>
  <b-modal
    :id="id"
    size="xl"
    button-size="sm"
    ref="modal"
    :title="prefix + title"
    hide-footer
    v-model="showTarefaAprovacaoSolicitanteModal"
    @close="cancelar"
    @hidden="cancelar"
  >
    <b-card bg-variant="light">
      <b-card>
        <div>
          <span style="font-size: 16px">
            <strong>Pedido:</strong> {{ pedido.id }}<br />
            <strong>Solicitante:</strong>
            {{ tarefa.departamentoSolicitante.descricao }} <br />
            <strong>Data:</strong> {{ formatarData(tarefa.dataCriacao) }}
            <br />
            <strong>Justificativa:</strong> {{ pedido.justificativa }}
            <br />
          </span>
        </div>
      </b-card>

      <span style="font-size: 16px">
        <strong>Tarefa:</strong> {{ tarefa.tipoTarefaPedido.descricao }} <br />
        <strong>Status:</strong> {{ tarefa.status.descricao }} <br />
        <br />
      </span>

      <b-table
        id="t-tarefa-item"
        responsive
        class="mt-2"
        small
        :items="itens"
        :fields="fieldsTabelaItens"
        :busy="this.busy"
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template #head(aceito)>
          <span class="d-flex gap-1" style="padding-left: 130px">
            Aceito
            <b-form-checkbox
              :disabled="isVisualizacao"
              @change="marcarTodosAceito"
              v-model="todosMarcados"
            ></b-form-checkbox>
          </span>
        </template>

        <template #cell(aceito)="data">
          <b-form-radio
            :disabled="isVisualizacao"
            v-model="data.item.aceito"
            :name="`radio-aceito-${data.index}`"
            :value="true"
          ></b-form-radio>
        </template>

        <template #cell(naoAceito)="data">
          <b-form-radio
            :disabled="isVisualizacao"
            v-model="data.item.aceito"
            :name="`radio-aceito-${data.index}`"
            :value="false"
          ></b-form-radio>
        </template>
      </b-table>
      <b-col lg="12" sm="12" class="text-left">
        <b-form-group label-for="textarea-formatter" class="col-12">
          <label for="textarea-auto-height">Observação:</label>
          <b-form-textarea
            :disabled="isVisualizacao"
            id="textarea-formatter"
            v-model="observacao"
            :required="false"
          >
          </b-form-textarea>
        </b-form-group>
      </b-col>

      <b-row class="text-center">
        <b-col cols="3"></b-col>
        <b-col cols="6">
          <b-button
            v-if="!isVisualizacao"
            id="salvarAprSolic"
            type="submit"
            variant="success"
            size="sm"
            :title="'Salvar'"
            @click="salvar(false)"
          >
            Salvar
            <b-tooltip target="salvarAprSolic" title="Salvar"></b-tooltip>
          </b-button>
          <b-button
            v-if="!isVisualizacao"
            id="ConcluirAprSolic"
            variant="primary"
            size="sm"
            class="ml-2"
            @click="concluir"
          >
            Concluir
            <b-tooltip
              target="ConcluirAprSolic"
              title="Prosseguir para a próxima tarefa"
            ></b-tooltip>
          </b-button>
          <b-button
            id="cancelarAprSolic"
            variant="danger"
            size="sm"
            class="ml-2"
            @click="cancelar"
          >
            Cancelar
            <b-tooltip target="cancelarAprSolic" title="Cancelar"></b-tooltip>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"

export default {
  name: "TarefasAprovacaoSolicitanteModal",
  data() {
    return {
      busy: false,
      showTarefaAprovacaoSolicitanteModal: true,
      itens: [],
      observacao: "",
    }
  },

  props: {
    id: String,
    pedido: Object,
    tarefa: Object,
    uri: String,
    isVisualizacao: {
      type: Boolean,
      value: false,
    },

    prefix: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "Tarefa",
    },
  },

  async beforeMount() {
    this.$pedidoTarefa = new ResourceService(
      `/api/pedidos/${this.pedido.id}/tarefas`
    )

    this.$tarefaService = new ResourceService("/api/tarefaspedido")
    this.tarefaItens()
  },

  computed: {
    todosMarcados() {
      return this.itens && this.itens.every(item => item.aceito)
    },

    fieldsTabelaItens() {
      return [
        {
          key: "itemPedido.almoxarifadoProduto.numero",
          label: "Número",
          tdClass: "",
          thStyle: "font-size: 16px; font-weight: 600;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "itemPedido.almoxarifadoProduto.produto.descricaoResumida",
          label: "Produto",
          tdClass: "",
          thStyle: "font-size: 16px; font-weight: 600;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "qtdSolicitada",
          label: "Solicitado",
          tdClass: "text-center",
          thStyle: "font-size: 16px; font-weight: 600;",
          tdStyle: "font-size: 13px",
          formatter: value => value || "-",
        },
        {
          key: "quantidadeAprovada",
          label: "Aprovado",
          tdClass: "text-center",
          thStyle: "font-size: 16px; font-weight: 600;",
          tdStyle: "font-size: 13px",
          formatter: value => value || "-",
        },
        {
          key: "quantidadeRetirada",
          label: "Retirado",
        },
        {
          key: "aceito",
          label: "Aceito",
          thStyle: "font-size: 16px;text-align:center",
          tdStyle: "font-size: 13px;text-align:center",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          key: "naoAceito",
          label: "Não Aceito",
          thStyle: "font-size: 16px;text-align:center ",
          tdStyle: "font-size: 13px;text-align:center",
          tdClass: "text-center",
          thClass: "text-center",
        },
      ]
    },
  },

  methods: {
    async tarefaItens() {
      this.busy = true;

      await this.$tarefaService
        .findById(`${this.tarefa.id}${this.uri}`)
        .then(response => {
          this.busy = false
          this.observacao = response.data.observacao

          response.data.itens.map(item => {
            item.aceito = null
            if (item.aceitoPeloSolicitante) {
              item.aceito = true
            } else if (item.recusadoPeloSolicitante) {
              item.aceito = false
            }
          })

          this.itens = response.data.itens
        })
    },

    marcarTodosAceito(valor) {
      this.itens.forEach(item => {
        item.aceito = valor ? true : null
        item.aceitoPeloSolicitante = valor
        item.recusadoPeloSolicitante = !valor
      })
    },

    async salvar(concluir) {
      this.$pedidoTarefa = new ResourceService(
        `/api/pedidos/${this.pedido.id}/tarefas`
      )
      try {
        const itens = this.itens.map(({ itemPedido, aceito }) => {
          let item = {
            itemPedidoId: itemPedido.id,
            aceitoPeloSolicitante: false,
            recusadoPeloSolicitante: false,
          }

          if (aceito === true) {
            item.aceitoPeloSolicitante = true
            item.recusadoPeloSolicitante = false
          } else if (aceito === false) {
            item.aceitoPeloSolicitante = false
            item.recusadoPeloSolicitante = true
          }

          return item;
        });

        this.busy = true;

        await this.$pedidoTarefa
          .put(`${this.tarefa.id}${this.uri}`, {
            observacao: this.observacao,
            itens,
          })
          .then(response => {
            this.busy = false;
            if (response.status === 200) {
              if (!concluir) {
                this.$notify({
                  type: "success",
                  message: "Tarefa salva com sucesso",
                })
                this.showTarefaAprovacaoSolicitanteModal = false
                this.$emit("tarefaAprovacaoSolicitanteFinalizado", {})
              } else {
                this.concluirTarefa()
              }
            }
          })
        } catch ({ response }) {
          this.$notify({ type: 'danger', message: response.data });
          return;
        }
    },

    isNull(value) {
      return value === undefined || value == null
    },

    async concluir() {
      this.salvar(true)
    },
    async concluirTarefa() {

      try {
        const itemNaoAvalido = this.itens.some(
          ({ aceito, naoAceito }) =>
            this.isNull(aceito) && this.isNull(naoAceito)
        )

        if (itemNaoAvalido) {
          this.$notify({
            type: "danger",
            message:
              "Todos os itens devem ser avaliados para que a tarefa seja finalizada",
          })
          return
        }

        const itens = this.itens.map(({ itemPedido, aceito }) => {
          let item = {
            itemPedidoId: itemPedido.id,
            aceitoPeloSolicitante: false,
            recusadoPeloSolicitante: false,
          }

          if (aceito === true) {
            item.aceitoPeloSolicitante = true
            item.recusadoPeloSolicitante = false
          } else if (aceito === false) {
            item.aceitoPeloSolicitante = false
            item.recusadoPeloSolicitante = true
          }

          return item
        });

        this.busy = true;

        await this.$tarefaService
          .put(`executaProximaTarefa`, {
            id: this.tarefa.id,
            pedido: this.pedido,
            itens,
            observacao: this.observacao,
          })
          .then(() => {
            this.busy = false;
            this.$notify({
              type: "success",
              message: "Tarefa finalizada com sucesso",
            })
            this.showTarefaAprovacaoSolicitanteModal = false
            this.$emit("tarefaAprovacaoSolicitanteFinalizado", {})
          })
        } catch ({ response }) {
          this.$notify({ type: 'danger', message: response.data });
          return;
        }
    },

    async cancelar() {
      this.showTarefaAprovacaoSolicitanteModal = false
      this.$emit("close")
    },

    formatarData(valor) {
      if (!valor) return ""

      const data = new Date(valor)
      const dia = data.getDate().toString().padStart(2, "0")
      const mes = (data.getMonth() + 1).toString().padStart(2, "0")
      const ano = data.getFullYear()
      const hora = data.getHours().toString().padStart(2, "0")
      const minutos = data.getMinutes().toString().padStart(2, "0")
      const segundos = data.getSeconds().toString().padStart(2, "0")

      return `${dia}/${mes}/${ano} ${hora}:${minutos}:${segundos}`
    },
  },
}
</script>

<style lang="scss">
.modal-footer,
.modal-body {
  padding: 0.25rem !important;
}

table {
  .form-control {
    padding: 3px 9px;
    height: 30px;
    text-align: right;
  }
}

.gap-1 {
  gap: 4px;
}
</style>
